import React from "react";
import RemoveMacModal from "./RemoveMacModal";
import PasswordModal from "./PasswordModal";
import SessionHistoryModal from "./SessionHistoryModal";
import OnuDetailsModal from "./OnuDetailsModal";
import AuthLogsModal from "./AuthLogsModal";
import VerificationModal from "./VerificationModal";
import VerifyAadhaarModal from "./VerifyAadhaarModal";
import OnlineSessionPanel from "./OnlineSessionPanel";

/**
 * Content of the Internet / DVPL detail tabs (Password, Remove MAC, ONU details, ...).
 *
 * These used to open as pop-ups. They are now shown inside the account card, next to the tab
 * list, like the OneBSS customer page. The same components are reused: InternetPlanCard.css
 * turns their pop-up frame into a plain panel when they sit inside `.internet-tabpanel`.
 *
 * `close` sends the card back to the Overview tab (used by Cancel / after a successful action).
 */
export const makeInternetPanelRenderer = ({
  accountId,
  info,
  token,
  operatorId,
  onu,
  auth,
  reload,
  afterChange,
}) => (key, close) => {
  const results = info?.results || {};
  switch (key) {
    case "password":
      return <PasswordModal open internetId={accountId} token={token} onClose={close} />;
    case "removemac":
      return (
        <RemoveMacModal
          open
          internetId={accountId}
          token={token}
          onClose={close}
          onSuccess={() => {
            close();
            afterChange && afterChange();
          }}
        />
      );
    case "sessions":
      return <SessionHistoryModal open internetId={accountId} token={token} onClose={close} />;
    case "onu":
      return (
        <OnuDetailsModal inline open onClose={close} loading={onu.loading} error={onu.error} data={onu.data} />
      );
    case "authlogs":
      return <AuthLogsModal open onClose={close} loading={auth.loading} error={auth.error} data={auth.data} />;
    case "verify":
      return (
        <VerificationModal
          open
          internetId={accountId}
          token={token}
          username={results.username_org}
          customerName={[results.firstname, results.lastname].filter(Boolean).join(" ")}
          onClose={close}
          onSuccess={() => reload && reload()}
        />
      );
    case "online":
      return (
        <OnlineSessionPanel
          accountId={accountId}
          isOnline={results.online === "ONLINE"}
          onLoggedOut={() => { reload && reload(); }}
        />
      );
    case "aadhaar":
      return (
        <VerifyAadhaarModal
          open
          onClose={close}
          internetId={accountId}
          mobile={results.mobile}
          operatorId={operatorId}
          token={token}
          onSuccess={() => {
            close();
            reload && reload();
            afterChange && afterChange();
          }}
        />
      );
    default:
      return null;
  }
};
